<template>
    <div :class="['typer','reveal',mode,isFadeOut ? 'fadeout': '']" ref="content">        
    </div>
</template>
<script>

import { splitLinesAndChars,splitLines } from "@/utils";
export default 
{
    //this component is for splitting rows and animating on reveal 
    //Each row will animate letter by letter 
    //Multiple rows will start with small delay after it's previous row
    //for each row we need to split the chars by <span></span>
    
    name: "typer",
    props: {
        mode:{
            default:'fxMask',//fxMask,fxLetterByLetter
            type:String
        },
        content:{
            default:'',
            type:String
        },
        startDelay:{
            default:0,
            type:Number
        },
        startOnLoad:
        {
            default:false,
            type:Boolean
        },
        contentIndex:
        {
            default:0,
            type:Number
        },
        isActive:
        {
            default:false,
            type:Boolean
        }
    },
    data()
    {
        return {
            isFadeOut:false,
            selectedIndex:0
        }
    },
    created()
    {
        //this.sectionData = this.siteData.SECTIONS[this.sectionIndex];
    },
    mounted()
    {
        this.initText(false);
    },
    watch:{
        isActive:function(newVal,oldVal)
        {
            //alert("newVal="+newVal);
            this.setTyperState(newVal);
        }
    },
    methods:
    {
        setTyperState(isTyperActive)
        {
            let contentEl = this.$refs.content;
            if(isTyperActive===true)
            {
                if(contentEl.classList.contains("active")==false){
                    contentEl.classList.add("active"); 
                }
            }
            else
            {
                if(contentEl.classList.contains("active")==true){
                    contentEl.classList.remove("active"); 
                }
            }

        },
        initText(changeFromWatch)
        {      
            var vm = this;
            var contentEl = this.$refs.content;

            //slight delay to avoid unmatching dom line splits
            setTimeout(() => {
                contentEl.innerHTML = this.content;     
                //fxMask,fxLetterByLetter
                if(vm.mode=="fxLetterByLetter"){
                    splitLinesAndChars(this.startDelay,1,contentEl,'splLine','splLineText');                 
                }
                if(vm.mode=="fxMask"){
                    splitLines(this.startDelay,1,contentEl,'splLine','splLineText');                 
                }

            }, 100);

            //if(this.startOnLoad || changeFromWatch){
/*             if(this.startOnLoad){
                if(contentEl.classList.contains("active")==false){
                    setTimeout(() => {
                       contentEl.classList.add("active"); 
                    }, 500);
                }
            }
 */            
            this.isFadeOut = false;
        }
    },
};
</script>

<style>
    .typer
    {
        opacity: 1;transition:opacity ease-in 0.2s;
    }
    .typer.fadeout
    {
        opacity: 0;
    }
    .typer.fxLetterByLetter .char
    {
        /* opacity: calc(1 - (0.02 * var(--char))); */
        opacity: 0;
        transition-duration: 0.05s;
        transition-property: all;
        transition-delay: calc(0.3s * var(--line) + (0.03s * var(--char)));
        /* transition-delay: calc(0.2s * var(--bzc)); */
    }
    .typer.fxLetterByLetter.active .char
    {      
        opacity: 1;
    }

    /* reaval mask mode */
    .typer.fxMask .splLineText
    {
        transition-duration: 1.5s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1.000);
        transition-delay: calc(0.2s * var(--line_index));
        clip-path: inset(0% 100% 0% 0%);/* need to animate from 100% to 0%)*/
        opacity: 0;
        text-shadow:0 0 7px #1e92d7,0 0 10px #1e92d7;        

    }
    .typer.fxMask.active .splLineText
    {      
        clip-path: inset(0% 0% 0% 0%);
        opacity: 1;
    }

    /*
    clip-path: inset(86px 0% 0% 0%);
    */

</style>